export default __webpack_public_path__ + "static/media/LS.dc8e7185.svg";